/* eslint-disable no-param-reassign */
import { needsIOSFix } from '../../../resources/scripts/utils/fullheightFix';

const setToggleState = (button, isPlaying) => {
  if (!button) {
    return;
  }

  button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
};

const handleBackgroundToggle = (block) => {
  const toggleButton = block.querySelector('[data-video-toggle]');
  const backgroundVideo = block.querySelector('[data-background-video]');
  const poster = block.querySelector('[data-video-poster]');

  if (!toggleButton || !backgroundVideo) {
    return;
  }

  const enableFallback = () => {
    block.classList.add('video-player--fallback');
    backgroundVideo.pause();
    if (poster) {
      poster.removeAttribute('hidden');
    }
  };

  backgroundVideo.addEventListener('error', enableFallback);
  backgroundVideo.addEventListener('stalled', enableFallback);
  backgroundVideo.addEventListener('abort', enableFallback);

  setToggleState(toggleButton, !backgroundVideo.paused);

  toggleButton.addEventListener('click', () => {
    if (backgroundVideo.paused) {
      backgroundVideo.play();
      setToggleState(toggleButton, true);

      return;
    }

    backgroundVideo.pause();
    setToggleState(toggleButton, false);
  });
};

const getDialogIframeSrc = (rawSrc) => {
  if (!rawSrc || rawSrc === 'about:blank') {
    return '';
  }

  try {
    const url = new URL(rawSrc, window.location.href);
    url.searchParams.set('autoplay', '1');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set('controls', '1');
    // The dialog is opened by a user click, so play with sound.
    // iOS blocks unmuted autoplay: YouTube then shows its play button and one tap starts it.
    url.searchParams.set('mute', '0');
    return url.toString();
  } catch (e) {
    return rawSrc;
  }
};

const openDialog = (dialog, dialogVideo, dialogIframe, dialogIframeSrc) => {
  if (!dialog) {
    return;
  }

  if (dialogIframe && dialogIframeSrc) {
    dialogIframe.setAttribute('src', getDialogIframeSrc(dialogIframeSrc));
  }

  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', 'open');
  }

  document.body.classList.add('lock-scroll');

  if (dialogVideo) {
    // eslint-disable-next-line no-param-reassign
    dialogVideo.currentTime = 0;
    dialogVideo.play().catch(() => null);
  }
};

const closeDialog = (dialog, dialogVideo, dialogIframe) => {
  if (!dialog) {
    return;
  }

  if (dialogVideo) {
    dialogVideo.pause();
  }

  if (dialogIframe) {
    dialogIframe.setAttribute('src', 'about:blank');
  }

  document.body.classList.remove('lock-scroll');

  if (typeof dialog.close === 'function') {
    dialog.close();

    return;
  }

  dialog.removeAttribute('open');
};

const initHeroBanner = () => {
  const banners = document.querySelectorAll('.hero-banner');

  if (needsIOSFix()) {
    banners.forEach((banner) => {
      banner.classList.add('hero-banner--no-sticky');
    });
  }

  banners.forEach((block) => {
    handleBackgroundToggle(block);

    const dialog = block.querySelector('[data-video-dialog]');
    const openTrigger = block.querySelector('[data-video-open]');
    const closeTrigger = block.querySelector('[data-video-dialog-close]');
    const dialogVideo = block.querySelector('[data-dialog-video]');
    const dialogIframe = block.querySelector('[data-dialog-iframe]');
    const dialogPoster = block.querySelector('[data-dialog-poster]');
    const dialogIframeSrc = dialogIframe
      ? (dialogIframe.getAttribute('data-src') || dialogIframe.getAttribute('src') || '')
      : '';

    if (dialogIframe && dialogIframeSrc && dialogIframeSrc !== 'about:blank') {
      dialogIframe.setAttribute('src', 'about:blank');
    }

    if (dialogIframe && dialogPoster) {
      dialogIframe.addEventListener('load', () => {
        if (dialogIframe.getAttribute('src') && dialogIframe.getAttribute('src') !== 'about:blank') {
          dialogPoster.remove();
        }
      });
    }

    if (openTrigger && dialog) {
      openTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        openDialog(dialog, dialogVideo, dialogIframe, dialogIframeSrc);
      });
    }

    if (closeTrigger) {
      closeTrigger.addEventListener('click', () => {
        closeDialog(dialog, dialogVideo, dialogIframe);
      });
    }

    if (dialog) {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
          closeDialog(dialog, dialogVideo, dialogIframe);
        }
      });

      dialog.addEventListener('cancel', () => {
        closeDialog(dialog, dialogVideo, dialogIframe);
      });
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-hero-banner', () => {
      initHeroBanner();
    });
  } else {
    initHeroBanner();
  }
});
